import { fetchAsObservable } from "fetcher!sofe";
import canopyUrls from "canopy-urls!sofe";
import { pluck } from "rxjs/operators";

export function getCounties(state) {
  return fetchAsObservable(`/api/states/${state}/counties`).pipe(pluck("counties"));
}
